import { Link } from "react-router-dom";
import { navLinks, site } from "@/mocks/site";
import { categories } from "@/mocks/categories";

export default function SiteFooter() {
  return (
    <footer className="mt-20 border-t border-background-200 bg-secondary-50">
      <div className="w-full px-4 py-14 md:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-fire-line text-lg" />
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">{site.name}</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              {site.slogan}。我们只做公开讨论的二次归纳，重点写在前三行，让你快速浏览就能看懂一场话题的来龙去脉。
            </p>
            <p className="mt-4 flex items-center gap-2 text-sm text-foreground-600">
              <i className="ri-mail-line text-primary-600" />
              <a href={`mailto:${site.email}`} className="cursor-pointer hover:text-primary-700">
                {site.email}
              </a>
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950">
              <a href="/topics" className="cursor-pointer">内容专题</a>
            </h4>
            <ul className="mt-4 space-y-2.5">
              {categories.slice(0, 4).map((c) => (
                <li key={c.slug}>
                  <Link
                    to="/topics"
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-700 cursor-pointer"
                  >
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950">
              <a href="/about" className="cursor-pointer">网站导航</a>
            </h4>
            <ul className="mt-4 space-y-2.5">
              {navLinks.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-700 cursor-pointer"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-3 border-t border-secondary-200 pt-6 sm:flex-row sm:items-center">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} {site.name} · 娱乐话题速览，理性吃瓜
          </p>
          <p className="text-xs text-foreground-500">
            内容仅做公开信息的整理归纳，不传播未经证实的信息
          </p>
        </div>
      </div>
    </footer>
  );
}